import React from "react";

export default function Popup(props) {
  let i = 0;

  return (
    <>
      <div
        className="backdrop visible active"
        style={{ display: props.show === true ? "" : "none" }}
      />

      <div
        className="popup-container popup-showing active"
        style={{
          position: "absolute",
          display: props.show === true ? "" : "none",
        }}
      >
        <div className="popup">
          <div className="popup-head">
            <h3 className="popup-title ng-binding" ng-bind-html="title">
              {props.title}
            </h3>
          </div>
          <div className="popup-body">{props.children}</div>
          <div className="popup-buttons">
            {props.botoes.map((botao) => (
              <button
                className="button ng-binding button-positive"
                onClick={() => botao.acao()}
                key={i++}
              >
                {botao.texto}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
